import { NullAstVisitor } from "@angular/compiler";
import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { of } from "rxjs";
import { catchError } from "rxjs/operators";
import { GlobalService } from "src/app/global.service";
import { HttpService } from "src/app/http.service";

@Component({
  selector: "app-agent-order-edit",
  templateUrl: "./agent-order-edit.component.html",
  styleUrls: ["./agent-order-edit.component.scss"],
})
export class AgentOrderEditComponent implements OnInit {
  selected_date: any;
  selected_business_code: any;
  product_list: any;
  session_list: any;
  product_form_dict: any = {};
  is_data_available = false;
  amount_before_edit = 0;
  pay_amount = 0;
  customer_wallet = 0; // initial wallet
  customer_wallet_after_edit: any; // after edit the order
  enable_wallet_checkbox = false;
  final_customer_wallet = 0; // final customer wallet price
  is_wallet_enabled = false;
  product_availability: any;
  enable_minimum_warning_for_loose_milk: boolean = false;
  product_groupby_list: any;
  business_type_id: any;
  product_quantity_variation_list: any;
  disable_button = false;
  business_details: any = null;
  route_indent_prepate_status_per_session = { 1: false, 2: false };
  employee_user_type_id: any;
  is_session_wise_edit = { 1: false, 2: false };
  milk_product_list = [];
  counter_id: any;
  business_group_id: any;
  business_id: any;
  min_max_limit_dict: any;

  // Product group limit tracking
  productGroupTotals: { [groupId: number]: number } = {};
  productGroupNames: { [groupId: number]: string } = {
    1: 'Milk',
    2: 'Fermented Products',
    3: 'Loose Milk'
  };
  sessionNames: { [sessionId: number]: string } = {
    1: 'Morning',
    2: 'Evening'
  };

  constructor(
    public dialogRef: MatDialogRef<AgentOrderEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpService: HttpService,
    private global: GlobalService
  ) {
    this.selected_date = data["selected_date"];
    this.selected_business_code = data["selected_business_code"];
    this.business_type_id = data["business_type_id"];
    this.counter_id = data["counter_id"];
    let data_dict = {
      selected_date: this.selected_date,
      from: "portal",
      business_code: this.selected_business_code,
    };
    this.httpService.checkEditOrderPermission(data_dict).subscribe(
      (data) => {
        if (!data["permission_available"]) {
          alert(
            "You cannot edit this order. This order placed by " +
            data["ordered_person_firstname"]
          );
          this.dialogRef.close();
          return false;
        }
      },
      (error) => {
        // Error handling
      }
    );
    this.serveSaleDetails();
    this.httpService.getEmployeeUserType().subscribe(
      (data) => {
        this.employee_user_type_id = data;
      },
      (error) => {
        // Error handling
      }
    );
  }

  async serveSaleDetails() {
    let data_dict = {
      request_from: "portal",
      order_date: this.selected_date,
      business_code: this.selected_business_code.toString(),
    };
    this.httpService.getProductList(data_dict).subscribe(
      (data) => {
        this.business_group_id = data["business_group_id"];
        this.business_id = data["business_id"];
        this.business_type_id = data["business_type_id"];
        this.product_list = data["product_list"];
        this.session_list = data["session_list"];
        this.product_availability = data["product_availability"];
        this.product_groupby_list = data["product_groupby_list"];
        this.product_quantity_variation_list =
          data["product_quantity_variation_list"];
        this.min_max_limit_dict = data["min_max_limit_dict"];
        this.milk_product_list = data["milk_product_list"];

        let data_dict = {
          from: "portal",
          selected_date: this.selected_date,
          business_code: this.selected_business_code,
        };
        this.httpService.serveSingleSalegroup(data_dict).subscribe(
          (sale_details) => {
            let order_data = sale_details["order_details"];
            this.business_details = sale_details["business_details"];
            this.customer_wallet = sale_details["current_wallet_amount"];
            this.customer_wallet_after_edit =
              sale_details["current_wallet_amount"];
            this.is_data_available = true;
            this.product_form_dict["session"] = {};
            this.amount_before_edit = order_data["total_price_per_date"];
            this.product_form_dict["total_price_per_date"] =
              order_data["total_price_per_date"];
            this.product_form_dict["total_difference"] = 0;
            this.product_form_dict["pay_amount"] = 0;
            this.product_form_dict["total_price_per_product"] = {};
            this.product_form_dict["total_price_per_session"] = {};

            data["session_list"].forEach((session_element) => {
              this.product_form_dict["session"][session_element.id] = {};
              if (
                order_data["total_price_per_session"].hasOwnProperty(
                  session_element.id
                )
              ) {
                this.product_form_dict["total_price_per_session"][
                  session_element.id
                ] = order_data["total_price_per_session"][session_element.id];
              } else {
                this.product_form_dict["total_price_per_session"][
                  session_element.id
                ] = 0;
              }
              if (order_data["session"].hasOwnProperty(session_element.id)) {

                this.product_form_dict["session"][session_element.id][
                  "product"
                ] = {};
                this.product_form_dict["session"][session_element.id][
                  "sale_group_id"
                ] = order_data["session"][session_element.id]["sale_group_id"];
                data["product_list"].forEach((product_element) => {
                  if (
                    order_data["session"][session_element.id]["product"].hasOwnProperty(
                      product_element.product_id
                    )
                  ) {
                    this.product_form_dict["session"][session_element.id][
                      "product"
                    ][product_element.product_id] =
                      order_data["session"][session_element.id]["product"][
                      product_element.product_id
                      ];
                    if (
                      order_data["session"][session_element.id]["product"][
                      product_element.product_id
                      ]["quantity"] === 0
                    ) {
                      this.product_form_dict["session"][session_element.id][
                        "product"
                      ][product_element.product_id]["quantity"] = null;
                    }
                  } else {
                    this.product_form_dict["session"][session_element.id][
                      "product"
                    ][product_element.product_id] = {
                      quantity: null,
                      price: 0,
                      sale_id: null,
                    };
                  }
                });
              } else {
                this.product_form_dict["session"][session_element.id][
                  "product"
                ] = {};
                this.product_form_dict["session"][session_element.id][
                  "sale_group_id"
                ] = null;
                data["product_list"].forEach((product_element) => {
                  this.product_form_dict["session"][session_element.id][
                    "product"
                  ][product_element.product_id] = {
                    quantity: null,
                    price: 0,
                    sale_id: null,
                  };
                });
              }
            });

            data["product_list"].forEach((product_element) => {
              let total_cost = 0;
              data["session_list"].forEach((session_element) => {
                total_cost +=
                  this.product_form_dict["session"][session_element.id][
                  "product"
                  ][product_element.product_id]["price"];
              });
              this.product_form_dict["total_price_per_product"][
                product_element.product_id
              ] = total_cost;
            });

            console.info(this.product_form_dict);
            this.getRouteIndentCloseStatus();
            this.calculateProductGroupTotals();
          },
          (error) => {
            // Error handling
          }
        );
      },
      (error) => {
        // Error handling
      }
    );
  }

  checkMinimumIsReached() {
    // This method is now handled by the new validation system
    return true;
  }

  getRouteIndentCloseStatus() {
    let data_dict = {
      selected_date: this.selected_date,
      selected_business_code: this.selected_business_code,
    };
    this.httpService.getRouteIndentStatusPerSession(data_dict).subscribe(
      (data) => {
        this.route_indent_prepate_status_per_session[1] = data[1];
        this.route_indent_prepate_status_per_session[2] = data[2];
      },
      (error) => {
        // Error handling
      }
    );
  }

  checkLooseMilkQuantityWarning(product_index) {
    this.enable_minimum_warning_for_loose_milk = false;

    if (this.product_groupby_list && this.product_groupby_list[3]) {
      this.product_groupby_list[3].forEach((loose_milk_id) => {
        this.session_list.forEach(session_element => {
          let value = this.product_form_dict['session'][session_element.id]['product'][loose_milk_id]['quantity'];
          if (value !== null && value !== 0) {
            if (value < this.product_list[product_index]['minimum_quantity']) {
              this.enable_minimum_warning_for_loose_milk = true;
            }
          }
        });
      });
    }
  }

  productQuantityChanged(
    session_id,
    product_id,
    product_price,
    product_index,
    product_quantity
  ) {
    let temp_quantity = this.product_form_dict["session"][session_id]["product"][
      product_id
    ]["quantity"];
    if (temp_quantity !== "") {
      this.is_session_wise_edit[session_id] = true;
      this.product_form_dict["session"][session_id]["product"][
        product_id
      ]["quantity"] = parseInt(
        this.product_form_dict["session"][session_id]["product"][
        product_id
        ]["quantity"]
      );
    } else {
      this.product_form_dict["session"][session_id]["product"][
        product_id
      ]["quantity"] = null;
    }
    let quantity = this.product_form_dict["session"][session_id]["product"][
      product_id
    ]["quantity"];
    if (this.product_list[product_index]["product_group_id"] === 3) {
      this.checkLooseMilkQuantityWarning(product_index);
      this.product_form_dict["session"][session_id]["product"][
        product_id
      ]["price"] = 0;
      this.product_quantity_variation_list[product_id].forEach((element) => {
        if (
          quantity >= element["min_quantity"] &&
          quantity <= element["max_quantity"]
        ) {
          this.product_form_dict["session"][session_id]["product"][
            product_id
          ]["price"] = quantity * element["mrp"];
        }
      });
    } else {
      this.product_form_dict["session"][session_id]["product"][
        product_id
      ]["price"] = quantity * product_price;
    }

    let total_cost = 0;
    let total_litre = 0;
    this.session_list.forEach((session_element) => {
      total_cost +=
        this.product_form_dict["session"][session_element.id]["product"][
        product_id
        ]["price"];
      total_litre +=
        (this.product_form_dict["session"][session_element.id]["product"][
          product_id
        ]["quantity"] * product_quantity) / 1000;
    });
    this.product_form_dict["total_price_per_product"][product_id] = total_cost;

    this.product_form_dict["total_price_per_date"] = 0;
    this.product_list.forEach((product_element) => {
      this.product_form_dict["total_price_per_date"] +=
        this.product_form_dict["total_price_per_product"][
        product_element.product_id
        ];
    });

    let total_cost_per_session = 0;
    this.product_form_dict["total_price_per_session"][session_id] = 0;
    this.product_list.forEach((product_element) => {
      total_cost_per_session +=
        this.product_form_dict["session"][session_id]["product"][
        product_element.product_id
        ]["price"];
    });
    this.product_form_dict["total_price_per_session"][session_id] =
      total_cost_per_session;

    this.product_form_dict["pay_amount"] = 0;
    this.product_form_dict["total_difference"] = 0;

    if (
      this.product_form_dict["total_price_per_date"] >
      this.amount_before_edit
    ) {
      this.product_form_dict["total_difference"] =
        this.product_form_dict["total_price_per_date"] -
        this.amount_before_edit;
      this.enable_wallet_checkbox = true;

      if (this.is_wallet_enabled) {
        this.product_form_dict["pay_amount"] =
          this.product_form_dict["total_difference"] -
          this.customer_wallet_after_edit;
        if (this.product_form_dict["pay_amount"] < 0) {
          this.product_form_dict["pay_amount"] = 0;
        }
      } else {
        this.product_form_dict["pay_amount"] =
          this.product_form_dict["total_difference"];
      }

      if (this.is_wallet_enabled) {
        this.final_customer_wallet =
          this.customer_wallet -
          this.product_form_dict["total_difference"];
        if (this.final_customer_wallet < 0) {
          this.final_customer_wallet = 0;
        }
      } else {
        this.final_customer_wallet = this.customer_wallet;
      }
    } else if (
      this.product_form_dict["total_price_per_date"] <
      this.amount_before_edit
    ) {
      this.enable_wallet_checkbox = false;
      this.product_form_dict["total_difference"] =
        this.product_form_dict["total_price_per_date"] -
        this.amount_before_edit;
      this.customer_wallet_after_edit +=
        this.amount_before_edit -
        this.product_form_dict["total_price_per_date"];
      this.final_customer_wallet = this.customer_wallet_after_edit;
    } else {
      this.enable_wallet_checkbox = false;
      this.customer_wallet_after_edit = this.customer_wallet;
      this.product_form_dict["total_difference"] = 0;
      this.final_customer_wallet = this.customer_wallet;
    }

    // Update product group totals
    this.calculateProductGroupTotals();
  }

  /**
   * Calculate current totals for each product group for UI display
   */
  calculateProductGroupTotals() {
    this.productGroupTotals = {};

    if (!this.product_form_dict || !this.product_form_dict.session) {
      return;
    }

    const sessionData = this.product_form_dict.session;

    // Calculate totals for each product group
    for (let i = 0; i < this.session_list.length; i++) {
      const session = this.session_list[i];
      const sessionId = session.id;

      for (let j = 0; j < this.product_list.length; j++) {
        const product = this.product_list[j];
        const productId = product.product_id;
        const productGroupId = product.product_group_id;

        const sessionEntry = sessionData[sessionId];
        const productEntry = sessionEntry ? sessionEntry.product[productId] : null;
        const quantity = productEntry ? productEntry.quantity || 0 : 0;

        if (quantity > 0) {
          const litres = (quantity * product.product_quantity) / 1000;

          if (!this.productGroupTotals[productGroupId]) {
            this.productGroupTotals[productGroupId] = 0;
          }

          this.productGroupTotals[productGroupId] += litres;
        }
      }
    }
  }

  checkConfirmButtonValid() {
    // Check if there are any validation errors using the new min_max_limit_dict system
    const validation = this.validateAllLimits();
    if (!validation.isValid) {
      return true; // Disable button if there are validation errors
    }

    // Check other conditions
    if (this.product_form_dict["total_price_per_date"] == 0) {
      return true;
    }

    if (this.enable_minimum_warning_for_loose_milk) {
      return true;
    }

    return false;
  }

  walletCheckboxChanged(event) {
    if (!event.checked) {
      this.is_wallet_enabled = false;
      this.product_form_dict["pay_amount"] =
        this.product_form_dict["total_difference"];
      this.final_customer_wallet = this.customer_wallet;
    } else {
      this.is_wallet_enabled = true;
      this.product_form_dict["pay_amount"] -=
        this.customer_wallet_after_edit;
      if (this.product_form_dict["pay_amount"] < 0) {
        this.product_form_dict["pay_amount"] = 0;
      }
    }
  }
  checkDisableForDeleteButton() {
    if (this.employee_user_type_id === 2) {
      return true;
    }
    return false;
  }

  checkExpiry(session, product) {
    let order_date_in_format = new Date(this.selected_date);
    let expiry_date: any = new Date(
      order_date_in_format.setDate(
        order_date_in_format.getDate() - session.expiry_day_before
      )
    );
    expiry_date = expiry_date.toISOString().split("T")[0];
    let expiry_date_and_time: any = new Date(
      expiry_date + " " + session.expiry_time
    );
    if (this.employee_user_type_id === 2) {
      return false;
    } else if (this.route_indent_prepate_status_per_session[session.id]) {
      return true;
    } else if (
      this.product_availability[session.id][product.product_id] === false
    ) {
      return true;
    } else if (new Date() > expiry_date_and_time) {
      return true;
    } else {
      return false;
    }
  }

  // ===== COMPREHENSIVE VALIDATION SYSTEM =====
  // This system validates in three levels:
  // 1. Overall product group limits (whole day)
  // 2. Session-wise limits  
  // 3. Individual product limits

  /**
   * Level 1: Check overall product group limits for whole day
   * IMPORTANT: Validates ALL product groups with limits if ANY product is entered (not just the group of the entered product)
   */
  validateProductGroupOverallLimits(): { isValid: boolean, errors: string[] } {
    const errors: string[] = [];

    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      return { isValid: true, errors: [] };
    }

    const sessionData = this.product_form_dict && this.product_form_dict.session;
    if (!sessionData) {
      return { isValid: true, errors: [] };
    }

    // Check if ANY product is entered in ANY session
    let anyProductEntered = false;
    this.session_list.forEach(session => {
      if (this.product_form_dict && this.product_form_dict.session && this.product_form_dict.session[session.id] && this.product_form_dict.session[session.id].product) {
        Object.keys(this.product_form_dict.session[session.id].product).forEach(productIdStr => {
          const productId = parseInt(productIdStr);
          const quantity = this.product_form_dict.session[session.id].product[productId].quantity;
          if (quantity > 0) {
            anyProductEntered = true;
          }
        });
      }
    });

    // If no products are entered, no validation needed
    if (!anyProductEntered) {
      return { isValid: true, errors: [] };
    }

    // Calculate whole day totals for ALL product groups
    const productGroupTotals: { [groupId: number]: number } = {};
    this.product_list.forEach(product => {
      const groupId = product.product_group_id;
      let groupTotal = 0;
      this.session_list.forEach(session => {
        const quantity = (this.product_form_dict && this.product_form_dict.session && this.product_form_dict.session[session.id] && this.product_form_dict.session[session.id].product && this.product_form_dict.session[session.id].product[product.product_id]) ? this.product_form_dict.session[session.id].product[product.product_id].quantity : 0;
        groupTotal += (quantity * product.product_quantity) / 1000; // Convert to litres
      });
      productGroupTotals[groupId] = (productGroupTotals[groupId] || 0) + groupTotal;
    });

    // Validate ALL product groups with limits, even if no product from that group is entered
    Object.keys(this.min_max_limit_dict.min_max_product_group_wholeday_limit).forEach(groupIdStr => {
      const groupId = parseInt(groupIdStr);
      const wholeDayTotal = productGroupTotals[groupId] || 0;
      const groupLimit = this.min_max_limit_dict.min_max_product_group_wholeday_limit[groupId];
      if (groupLimit) {
        const groupName = this.productGroupNames[groupId] || `Product Group ${groupId}`;
        // ONLY validate minimum if min_litre is NOT NULL
        if (groupLimit.min_litre !== null && groupLimit.min_litre !== undefined) {
          if (wholeDayTotal < groupLimit.min_litre) {
            errors.push(`${groupName} needs at least ${groupLimit.min_litre}L for the whole day (current: ${wholeDayTotal.toFixed(2)}L)`);
          }
        }
        // ONLY validate maximum if max_litre is NOT NULL  
        if (groupLimit.max_litre !== null && groupLimit.max_litre !== undefined) {
          if (wholeDayTotal > groupLimit.max_litre) {
            errors.push(`${groupName} cannot exceed ${groupLimit.max_litre}L for the whole day (current: ${wholeDayTotal.toFixed(2)}L)`);
          }
        }
      }
    });

    return { isValid: errors.length === 0, errors };
  }

  /**
   * Level 2: Check session-wise limits for product groups
   * IMPORTANT: Validates ALL product groups in a session when ANY product is entered in that session
   */
  validateProductGroupSessionLimits(): { isValid: boolean, errors: string[] } {
    const errors: string[] = [];

    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_session_limit) {
      return { isValid: true, errors: [] };
    }

    const sessionData = this.product_form_dict && this.product_form_dict.session;
    if (!sessionData) {
      return { isValid: true, errors: [] };
    }

    // Check which sessions have ANY products entered
    const sessionsWithProducts: { [sessionId: number]: boolean } = {};

    this.session_list.forEach(session => {
      let sessionHasProducts = false;
      if (this.product_form_dict && this.product_form_dict.session && this.product_form_dict.session[session.id] && this.product_form_dict.session[session.id].product) {
        Object.keys(this.product_form_dict.session[session.id].product).forEach(productIdStr => {
          const productId = parseInt(productIdStr);
          const quantity = this.product_form_dict.session[session.id].product[productId].quantity;
          if (quantity > 0) {
            sessionHasProducts = true;
          }
        });
      }
      sessionsWithProducts[session.id] = sessionHasProducts;
    });

    // Calculate session totals for ALL product groups
    const productGroupSessionTotals: { [groupId: number]: { [sessionId: number]: number } } = {};

    // Calculate session totals for each product group
    this.product_list.forEach(product => {
      const groupId = product.product_group_id;

      this.session_list.forEach(session => {
        const quantity = (this.product_form_dict && this.product_form_dict.session && this.product_form_dict.session[session.id] && this.product_form_dict.session[session.id].product && this.product_form_dict.session[session.id].product[product.product_id]) ? this.product_form_dict.session[session.id].product[product.product_id].quantity : 0;
        const sessionTotal = (quantity * product.product_quantity) / 1000; // Convert to litres

        if (!productGroupSessionTotals[groupId]) {
          productGroupSessionTotals[groupId] = {};
        }

        productGroupSessionTotals[groupId][session.id] = (productGroupSessionTotals[groupId][session.id] || 0) + sessionTotal;
      });
    });

    // Check session limits for ALL product groups when ANY product is entered in that session
    Object.keys(sessionsWithProducts).forEach(sessionIdStr => {
      const sessionId = parseInt(sessionIdStr);
      const sessionHasProducts = sessionsWithProducts[sessionId];

      // If this session has ANY products entered, validate ALL product groups
      if (sessionHasProducts) {
        const sessionLimits = this.min_max_limit_dict.min_max_product_group_session_limit[sessionId];
        if (sessionLimits) {
          Object.keys(sessionLimits).forEach(groupIdStr => {
            const groupId = parseInt(groupIdStr);
            const sessionTotal = productGroupSessionTotals[groupId] ? (productGroupSessionTotals[groupId][sessionId] || 0) : 0;

            const groupSessionLimit = sessionLimits[groupId];
            const groupName = this.productGroupNames[groupId] || `Product Group ${groupId}`;
            const sessionName = this.sessionNames[sessionId] || `Session ${sessionId}`;

            // ONLY validate minimum if min_litre is NOT NULL
            if (groupSessionLimit.min_litre !== null && groupSessionLimit.min_litre !== undefined) {
              if (sessionTotal < groupSessionLimit.min_litre) {
                errors.push(`${groupName} needs at least ${groupSessionLimit.min_litre}L for ${sessionName} session (current: ${sessionTotal.toFixed(2)}L)`);
              }
            }

            // ONLY validate maximum if max_litre is NOT NULL
            if (groupSessionLimit.max_litre !== null && groupSessionLimit.max_litre !== undefined) {
              if (sessionTotal > groupSessionLimit.max_litre) {
                errors.push(`${groupName} cannot exceed ${groupSessionLimit.max_litre}L for ${sessionName} session (current: ${sessionTotal.toFixed(2)}L)`);
              }
            }
          });
        }
      }
    });

    return { isValid: errors.length === 0, errors };
  }

  /**
   * Level 3: Check individual product limits
   */
  validateIndividualProductLimits(): { isValid: boolean, errors: string[] } {
    const errors: string[] = [];

    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_limit) {
      return { isValid: true, errors: [] };
    }

    const sessionData = this.product_form_dict && this.product_form_dict.session;
    if (!sessionData) {
      return { isValid: true, errors: [] };
    }

    // Track product totals (per session or per day based on is_per_session flag)
    const productDayTotals: { [productId: number]: number } = {};
    const productSessionTotals: { [productId: number]: { [sessionId: number]: number } } = {};

    // Calculate totals for each product
    this.product_list.forEach(product => {
      const productId = product.product_id;
      let dayTotal = 0;

      if (!productSessionTotals[productId]) {
        productSessionTotals[productId] = {};
      }

      this.session_list.forEach(session => {
        const quantity = (this.product_form_dict && this.product_form_dict.session && this.product_form_dict.session[session.id] && this.product_form_dict.session[session.id].product && this.product_form_dict.session[session.id].product[productId]) ? this.product_form_dict.session[session.id].product[productId].quantity : 0;
        productSessionTotals[productId][session.id] = quantity;
        dayTotal += quantity;
      });

      if (dayTotal > 0) {
        productDayTotals[productId] = dayTotal;
      }
    });

    // Check individual product limits - ONLY if limits are NOT NULL
    Object.keys(productDayTotals).forEach(productIdStr => {
      const productId = parseInt(productIdStr);
      const productLimit = this.min_max_limit_dict.min_max_product_limit[productId];

      if (productLimit) {
        const product = this.product_list && this.product_list.find(p => p.product_id === productId);
        const productName = product ? product.product_short_name : `Product ${productId}`;

        if (productLimit.is_per_session) {
          // is_per_session = TRUE: Validate Morning and Evening sessions SEPARATELY
          // Each session must meet the min/max limits individually
          Object.keys(productSessionTotals[productId]).forEach(sessionIdStr => {
            const sessionId = parseInt(sessionIdStr);
            const sessionQuantity = productSessionTotals[productId][sessionId];
            const sessionName = this.sessionNames[sessionId] || `Session ${sessionId}`;

            // ONLY validate minimum if min_packet is NOT NULL
            if (productLimit.min_packet !== null && productLimit.min_packet !== undefined) {
              if (sessionQuantity < productLimit.min_packet) {
                errors.push(`${productName} needs at least ${productLimit.min_packet} packets for ${sessionName} session (current: ${sessionQuantity})`);
              }
            }

            // ONLY validate maximum if max_packet is NOT NULL
            if (productLimit.max_packet !== null && productLimit.max_packet !== undefined) {
              if (sessionQuantity > productLimit.max_packet) {
                errors.push(`${productName} cannot exceed ${productLimit.max_packet} packets for ${sessionName} session (current: ${sessionQuantity})`);
              }
            }
          });
        } else {
          // is_per_session = FALSE: Validate Morning + Evening sessions COMBINED (together)
          // Total of both sessions must meet the min/max limits
          const dayQuantity = productDayTotals[productId];

          // ONLY validate minimum if min_packet is NOT NULL
          if (productLimit.min_packet !== null && productLimit.min_packet !== undefined) {
            if (dayQuantity < productLimit.min_packet) {
              errors.push(`${productName} needs at least ${productLimit.min_packet} packets per day (current: ${dayQuantity})`);
            }
          }

          // ONLY validate maximum if max_packet is NOT NULL
          if (productLimit.max_packet !== null && productLimit.max_packet !== undefined) {
            if (dayQuantity > productLimit.max_packet) {
              errors.push(`${productName} cannot exceed ${productLimit.max_packet} packets per day (current: ${dayQuantity})`);
            }
          }
        }
      }
    });

    return { isValid: errors.length === 0, errors };
  }

  /**
   * Master validation method that calls all three validation levels
   */
  validateAllLimits(): { isValid: boolean, errors: string[] } {
    const allErrors: string[] = [];

    // Level 1: Product group overall limits
    const overallValidation = this.validateProductGroupOverallLimits();
    if (!overallValidation.isValid) {
      allErrors.push(...overallValidation.errors);
    }

    // Level 2: Product group session limits
    const sessionValidation = this.validateProductGroupSessionLimits();
    if (!sessionValidation.isValid) {
      allErrors.push(...sessionValidation.errors);
    }

    // Level 3: Individual product limits
    const individualValidation = this.validateIndividualProductLimits();
    if (!individualValidation.isValid) {
      allErrors.push(...individualValidation.errors);
    }

    return { isValid: allErrors.length === 0, errors: allErrors };
  }

  // ===== UI HELPER METHODS FOR DISPLAYING LIMITS =====

  /**
   * Check if a product group has whole day limits configured
   */
  hasWholeDayLimits(groupId: number): boolean {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      return false;
    }
    const limits = this.min_max_limit_dict.min_max_product_group_wholeday_limit;
    const groupLimits = limits[groupId];
    // Only return true if at least one limit (min or max) is not null
    return groupLimits && (groupLimits.min_litre !== null || groupLimits.max_litre !== null);
  }

  /**
   * Get whole day limits for a product group
   */
  getWholeDayLimit(groupId: number): any {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      return null;
    }
    const limits = this.min_max_limit_dict.min_max_product_group_wholeday_limit;
    return limits[groupId] || null;
  }

  /**
   * Get color for group limit display (green = valid, red = invalid, black = no limits)
   */
  getGroupLimitColor(groupId: number): string {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_wholeday_limit) {
      return 'black';
    }
    const limits = this.min_max_limit_dict.min_max_product_group_wholeday_limit;
    const limit = limits[groupId];
    if (!limit) {
      return 'black';
    }

    const current = this.productGroupTotals[groupId] || 0;

    if (limit.min_litre !== null && current < limit.min_litre) {
      return 'red';
    }

    if (limit.max_litre !== null && current > limit.max_litre) {
      return 'red';
    }

    return 'green';
  }

  /**
   * Get session minimum limit for a product group
   */
  getSessionMin(groupId: number, sessionId: number): number | null {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_session_limit || !groupId || !sessionId) {
      return null;
    }
    const sessionLimits = this.min_max_limit_dict.min_max_product_group_session_limit[sessionId];
    if (!sessionLimits || !sessionLimits[groupId]) {
      return null;
    }
    return sessionLimits[groupId].min_litre;
  }

  /**
   * Get session maximum limit for a product group
   */
  getSessionMax(groupId: number, sessionId: number): number | null {
    if (!this.min_max_limit_dict || !this.min_max_limit_dict.min_max_product_group_session_limit || !groupId || !sessionId) {
      return null;
    }
    const sessionLimits = this.min_max_limit_dict.min_max_product_group_session_limit[sessionId];
    if (!sessionLimits || !sessionLimits[groupId]) {
      return null;
    }
    return sessionLimits[groupId].max_litre;
  }

  /**
   * Get current session total for a product group
   */
  getSessionCurrent(groupId: number, sessionId: number): number {
    if (!this.product_form_dict || !this.product_form_dict.session || !this.product_form_dict.session[sessionId]) {
      return 0;
    }

    const sessionData = this.product_form_dict.session[sessionId];
    let total = 0;

    // Calculate total for this product group in this session
    this.product_list.forEach(product => {
      if (product.product_group_id === groupId) {
        const productEntry = sessionData.product ? sessionData.product[product.product_id] : null;
        const quantity = productEntry ? productEntry.quantity || 0 : 0;
        total += (quantity * product.product_quantity) / 1000;
      }
    });

    return total;
  }

  /**
   * Get color for session limit display
   */
  getSessionLimitColor(groupId: number, sessionId: number): string {
    const current = this.getSessionCurrent(groupId, sessionId);
    const minLimit = this.getSessionMin(groupId, sessionId);
    const maxLimit = this.getSessionMax(groupId, sessionId);

    if (minLimit !== null && current < minLimit) {
      return 'red';
    }

    if (maxLimit !== null && current > maxLimit) {
      return 'red';
    }

    return 'green';
  }

  async updateClicked() {
    let session_list = [];
    if (this.is_session_wise_edit[1]) {
      session_list.push(1);
    }
    if (this.is_session_wise_edit[2]) {
      session_list.push(2);
    }
    let data_dict = {
      business_code: this.selected_business_code,
      order_date: this.selected_date,
      session_list: session_list,
    };
    this.httpService.checkIndentStatus(data_dict).subscribe(
      (data) => {
        // Validate using new min_max_limit_dict structure
        const validation = this.validateAllLimits();
        if (!validation.isValid) {
          alert(validation.errors.join("\n"));
          return false;
        }

        if (data) {
          let data_dict = {
            product_form_details: this.product_form_dict,
            selected_date: this.selected_date,
            final_customer_wallet: this.final_customer_wallet,
            final_price: this.product_form_dict["pay_amount"],
            business_code: this.selected_business_code,
            from: "portal",
          };
          this.disable_button = true;
          this.httpService
            .updateSelectedSaleGroup(data_dict)
            .pipe(
              catchError((error) => {
                if (error.status === 400) {
                  alert(error["error"]["message"]);
                }
                this.closeDialog(false);
                this.disable_button = false;
                // Return an empty observable to keep the stream alive
                throw error;
              })
            )
            .subscribe(
              (data) => {
                this.disable_button = false;
                this.closeDialog(true);
              }
            );
        } else {
          alert("Indent taken for this route you cannot order");
          this.closeDialog(false);
          this.disable_button = false;
          return false;
        }
      },
      (error) => {
        // Error handling
      }
    );
  }

  deleteOrderIsCliked() {
    if (confirm("இந்த ஆர்டரை கண்டிப்பாக நீக்க வேண்டுமா?")) {
      let data_dict = {
        selected_date: this.selected_date,
        business_code: this.selected_business_code,
        // 'counter_id':this.counter_id,
        deleted_amount: this.amount_before_edit,
        business_type_id: this.business_type_id,
      };
      this.httpService.deleteSelectedOrder(data_dict).subscribe(
        (data) => {
          this.global.showSnakeBar("Order has been removed");
          this.closeDialog(true);
        },
        (error) => {
          // Error handling
          this.global.showSnakeBar("Error while deteting this order");
        }
      );
    }
  }
  closeDialog(data) {
    this.dialogRef.close(data);
  }

  ngOnInit() { }
}
